import { InputSelect } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaSearch } from 'react-icons/fa';
import * as Styled from '../../styled';
import type { MapFiltersProps } from './types';

export const MapFilters: FC<MapFiltersProps> = (props) => {
  const { proSearch } = props;
  const { translate } = useTranslation();

  return (
    <Styled.MapProSearchFormContainer>
      <InputSelect<string>
        placeholder={translate('common.inputs.where.placeholder')}
        value={proSearch.tempValues.location ?? proSearch.values.location}
        search={proSearch.inputValues.location}
        selectOptions={proSearch.options.location}
        onSearchChange={(search) => {
          proSearch.fieldChangeHandler({ type: 'location', value: search });
        }}
        onSelect={(selected) => {
          proSearch.fieldSelectHandler({ type: 'location', value: selected });
        }}
      />
      <Styled.MapProSearchFormButton color="blue" type="submit" onClick={proSearch.submit} shrink>
        <FaSearch />
      </Styled.MapProSearchFormButton>
    </Styled.MapProSearchFormContainer>
  );
};
